import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  price: {
    fontFamily: 'Roboto !important',
    fontWeight: '500 !important',
    fontSize: '22px !important',
    color: 'rgba(0, 0, 0, 0.87) !important',
    letterSpacing: '0.15px !important',
    lineHeight: '33px',
    textAlign: 'left',
    padding: '0px 16px',
  },
}));
